module.exports = __webpack_public_path__ + "static/media/Sem_Título11.b648039a.jpg";